module.exports = ".align-buttons {\n  text-align: right; }\n\n.comment {\n  float: left;\n  width: 100%;\n  height: auto; }\n\n.textinput {\n  float: left;\n  width: 100%;\n  min-height: 75px;\n  outline: none;\n  resize: none;\n  border: 1px solid grey; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-update-technician-forklift-report/master-update-technician-forklift-report.component.scss
// module id = ./src/app/master/master-update-technician-forklift-report/master-update-technician-forklift-report.component.scss
// module chunks = main